export const getFieldLabel = (variableName) => {
  const labelMap = {
    'bank.iban': 'IBAN',
    'bank.accountNumber': 'Account Number',
    'bank.routingNumber': 'Routing Number',
    'bank.code': 'Bank Code',
    'bank.bankCode': 'Bank Code',
    'bank.name': 'Bank Name',
    'bank.swift': 'SWIFT Code',
    'bank.bic': 'BIC/SWIFT Code',
    'bank.branchCode': 'Branch Code',
    'accountHolder.name': 'Account Holder Name',
    'accountHolder.firstName': 'First Name',
    'accountHolder.lastName': 'Last Name',
    'accountHolder.address.streetLine1': 'Street Address',
    'accountHolder.address.streetLine2': 'Address Line 2',
    'accountHolder.address.city': 'City',
    'accountHolder.address.stateRegionProvince': 'State/Province',
    'accountHolder.address.postalCode': 'Postal Code',
    'accountHolder.address.country': 'Country',
    'accountHolder.email': 'Email',
    'accountHolder.phone': 'Phone',
    'accountHolder.documentId': 'Document ID',
    'accountHolder.documentType': 'Document Type',
  };

  if (labelMap[variableName]) {
    return labelMap[variableName];
  }

  const parts = variableName.split('.');
  const lastPart = parts[parts.length - 1];
  return lastPart
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
};

export const getFieldPath = (variableName) => variableName.replace(/\./g, '_');

export const setNestedValue = (obj, path, value) => {
  const keys = path.split('.');
  let current = obj;
  keys.slice(0, -1).forEach((key) => {
    if (!current[key]) {
      current[key] = {};
    }
    current = current[key];
  });
  current[keys[keys.length - 1]] = value;
};

export const getNestedValue = (obj, path) => {
  const keys = path.split('.');
  let current = obj;
  keys.forEach((key) => {
    if (current != null) {
      current = current[key];
    }
  });
  return current;
};

export const buildRequestObject = (requirements, formData) => {
  const requestObj = {};

  requirements.forEach((req) => {
    let value;
    let fieldPath;

    if (req.key) {
      value = formData[req.key];
      fieldPath = req.key;
    } else if (req.field) {
      const flatKey = getFieldPath(req.field);
      value = formData[flatKey] || formData[req.field] || getNestedValue(formData, req.field);
      fieldPath = req.field;
    } else if (req.data) {
      const flatKey = getFieldPath(req.data);
      value = formData[flatKey] || formData[req.data] || getNestedValue(formData, req.data);
      fieldPath = req.data;
    } else if (req.variableName) {
      const flatKey = getFieldPath(req.variableName);
      value = formData[flatKey] || formData[req.variableName] || getNestedValue(formData, req.variableName);
      fieldPath = req.variableName;
    }

    if (value !== undefined && value !== null && value !== '') {
      if (fieldPath && fieldPath.includes('.')) {
        setNestedValue(requestObj, fieldPath, value);
      } else {
        const fieldKey = req.key || req.field || req.data || req.variableName;
        requestObj[fieldKey] = value;
      }
    }
  });

  return requestObj;
};
